import React from 'react'
import {withRouter} from 'react-router-dom'
import './style.css'
import {GroupBuyingProvider} from "./store/useGroupBuyingContext"
import GroupBuyingLayout from "./layout"


const PlatformSetting = () => {
    return (
        <GroupBuyingProvider>
            <GroupBuyingLayout/>
        </GroupBuyingProvider>
    )
}

export default withRouter(PlatformSetting)



// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/index.js